import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-4-4h-4v-2h4V5h-6v2h4v2h-4v6h6v-2z"
}), 'Filter2Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Filter2Sharp.js
// module id = 3583
// module chunks = 2